module.exports = __webpack_public_path__ + "static/media/evjf.5a069541.png";